import { RevokeAccessDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRevokeAccess = () => {
  const [revokeAccess, { loading }] = useMutation(RevokeAccessDocument, {
    extractorFn: (data) => data.companiesMutations.revokeAccessCompaniesCompany,
  })

  return {
    loading,
    revokeAccess(companyId: number) {
      return revokeAccess({
        variables: {
          id: companyId,
        },
      })
    },
  }
}

export default useRevokeAccess
